import React, { Component } from 'react';
import './Licenses.css'


class Licenses extends Component {
    constructor(props) {
        super(props)

        this.state = {
            license: []
        }
    }


    // componentWillReceiveProps(incomingData) {
    //     methods = incomingData.methodDetails.shipment_tracking_method
    // }

    static getDerivedStateFromProps(nextProps, prevState) {
        // methods = nextProps.methodDetails.shipment_tracking_method
        return {
            license: nextProps.transporter_data.license
        }
    }

    render() {
        return (
            <div>
                <h3 className="data_header">Licenses/Certifications</h3>
                <div className='overflow-auto pb-2' >
                    {this.state.license?.fssai === "yes" ? (<div>
                        <div>FSSAI - {this.state.license?.cat_4 === "yes" ? "CAT 4" : null}{", "}{this.state.license?.cat_5 === "yes" ? "CAT 5" : null}{", "}{this.state.license?.cat_9 === "yes" ? "CAT 9" : null}</div>
                    </div>) : 
                    "Details not available"}
                </div>
            </div>
        )
    }
}

export default Licenses
